import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { UserService } from 'src/app/services/api/user.service';
import { MatDialog } from '@angular/material/dialog';
import { RouterSegments } from 'src/app/models/router-segments';
import { TenantService } from 'src/app/services/api/tenant.service';
@Component({
  selector: 'app-tenant-bookmark',
  templateUrl: './tenant-bookmark.component.html',
  styleUrl: './tenant-bookmark.component.scss',
  standalone: false
})
export class TenantBookmarkComponent implements OnInit {

  bookmarkList: any[];
  groupedBookmarks: any[] = [];
  isLoading = false;
  searchText: string = '';
  RouterSegments = RouterSegments;
  tenantId: string;
  deletingGroupId: string | null = null;

  constructor(public dateTimeFormatService: DateTimeFormatService, private router: Router,
    private authService: AuthService, private sidenavService: SidenavService,
    private customToastrService: CustomToastrService, private userService:UserService, private dialog:MatDialog, private activatedRoute: ActivatedRoute, private tenantService: TenantService) { }

  ngOnInit(): void {
    this.loadBookmarks();
  }

  loadBookmarks(): void {
    const userId = this.authService?.principal?.attributes?.email;
  
    if (!userId) {
      this.bookmarkList = [];
      this.groupedBookmarks = [];
      return;
    }

    this.isLoading = true;
    this.userService.getBookmarks(userId).subscribe({
      next: (res: any[]) => {
        this.bookmarkList = res;  
        this.groupBookmarks();
        this.isLoading = false;
      },
      error: () => {
        this.bookmarkList = [];
        this.groupedBookmarks = [];
        this.isLoading = false;
      }
    });
}

buildGrouped(list: any[], expand = false) {
    const map = new Map();

    list.forEach(item => {
      const key = item.tenantId;

      if (!map.has(key)) {
        map.set(key, {
          tenantName: item.tenantId,
          expanded: expand,
          environments: []
        });
      }

      map.get(key).environments.push({
        name: item.instanceName,
        id: item.instanceId,
        bookmarkId: item.id,
        blueprintId: item.blueprintId,
        tenantId: item.tenantId
      });
    });

    return Array.from(map.values());
  }

   groupBookmarks() {
    this.groupedBookmarks = this.buildGrouped(this.bookmarkList);
  }

onSearch(): void {
  if (!this.searchText) {
    this.groupBookmarks();
    return;
  }

  const search = this.searchText.toLowerCase();

  const filtered = this.bookmarkList.filter(item =>
    item.instanceName?.toLowerCase().includes(search) ||
    item.tenantId?.toLowerCase().includes(search)
  );

  this.groupedBookmarks = this.buildGrouped(filtered, true);
}

toggleGroup(selectedGroup): void {
  if (this.searchText) {
    selectedGroup.expanded = !selectedGroup.expanded;
    return;
  }
  this.groupedBookmarks.forEach(group => {
    group.expanded = group === selectedGroup ? !group.expanded : false;
  });
}

deleteBookmark(bookmarkId: string, tenantId: string): void {
  if (!bookmarkId) return;
    this.deletingGroupId = tenantId;
    this.userService.deleteBookmark(bookmarkId).subscribe({
      next: () => {
          this.bookmarkList = this.bookmarkList.filter(item => item.id !== bookmarkId);
          if (this.searchText) {
            this.searchText = '';
          }
          this.groupBookmarks();
          this.deletingGroupId = null;
          this.userService.notifyBookmarkRefresh();
        },
        error: () => {
          this.deletingGroupId = null;
         }
      });
}

rowClick(data): void {
    this.sidenavService.closeRightSidenav(); 
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    this.router.navigate([this.authService.principal.provider, RouterSegments.TENANT, data.tenantId, RouterSegments.BLUEPRINTS,
    data.blueprintId, RouterSegments.ENVIRONMENT,data.id]);
  });
}
}
